<template>
  <f7-popup :color-theme="themeColor" style="overflow-y: auto;">
    <div style="float: right; margin: 10px; font-size: 24px;" @click="$f7.popup.close()">
      <font-awesome-icon icon="times" />
    </div>
    <div style="margin: 50px 20px; font-size: 36px; overflow-wrap: break-word;">
      {{ item.specialRequests }}
    </div>
  </f7-popup>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SpecialRequestsPopup',
  dependencies: ['themeColor'],
  data () {
    return {
      orderId: parseInt(this.orderIdProp),
      itemInstanceId: this.itemIdProp
    }
  },
  props: {
    storeIdProp: String,
    orderIdProp: String,
    itemIdProp: String
  },
  computed: {
    ...mapState('orderModule', ['channels']),
    order () {
      return this.channels.main.orderList.find(order => parseInt(order.id) === this.orderId) ||
        this.channels.secondary.orderList.find(order => parseInt(order.id) === this.orderId)
    },
    item () {
      return this.order.data.items.find(i => i.instanceId === this.itemInstanceId)
    }
  }
}
</script>
